module.exports = __webpack_public_path__ + "static/media/roomgo-logo.403e3313.svg";